<template>
  <div>
    <wc-page-title title='Paid Invoices'>
      <template v-slot:rightSide>
        <wc-show-archived-button v-model='showArchived' @toggleShowArchived='showArchived = !showArchived' showArchivedText='Show ONLY Archived'>
        </wc-show-archived-button>
        <wc-toolbar-search v-model='search'></wc-toolbar-search>
      </template>
    </wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box hideToolbar
          >
            <v-data-table
              dense
              sort-by='date_due'
              :search='search'
              :items='filteredInvoices'
              :headers='headers'
              @click:row='openInvoice'
            >
              <template v-slot:item.date_due='{ item }'>
                {{ item.date_due | shortDate }}
              </template>
              <template v-slot:item.number='{ item }'>
                {{ item.number }}
                <wc-archived v-if='item.archived'></wc-archived>
              </template>
              <template v-slot:item.status='{ item }'>
                <status-chip :invoice='item' small></status-chip>
              </template>
              <template v-slot:item.bill_to_obj.name_display='{ item }'>
                <span v-if='item.bill_to'>
                  {{ item.bill_to_obj.name_display }}
                </span>
              </template>
              <template v-slot:item.project='{ item }'>
                <span v-if='item.project'>
                  {{ item.project_obj.name }}
                </span>
              </template>
              <template v-slot:item.division_display='{ item }'>
                <span v-if='item.division_display'>
                  <wc-division-nai :division_obj='findDiv(item.division_display)'></wc-division-nai>
                </span>
              </template>
              <template v-slot:item.amount_os='{ item }'>
                {{ item.amount_os | decMoney }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';
import StatusChip from '@/modules/accounting/components/invoice/StatusChip';
import _ from 'lodash';

export default {
  name: 'accounting-unpaid-invoices',
  data: () => ({
    isLoading: true,
    search: '',
    invoices: [],
    showArchived: false,
    headers: [
      { text: 'Invoice Date', value: 'invoice_date' },
      { text: 'Inv #', value: 'number' },
      { text: 'Bill to', value: 'bill_to_display' },
      { text: 'Project', value: 'project_display' },
      { text: 'Division', value: 'division_display' },
      { text: 'Status', value: 'status', align: 'center' },
      { text: 'Amount OS', value: 'amount_os', align: 'right' }
    ]
  }),
  computed: {
    filteredInvoices () {
      return this.showArchived ? this.invoices.filter(i => { return i.archived }) : this.invoices.filter(i => { return !i.archived })
    },
    divs () {
    return _.orderBy(this.$store.state.misc.divisions, 'order')
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.invoices = await accountingAPI.getPaidInvoices()
      this.isLoading = false
    },
    openInvoice (item) {
      this.$router.push({ name: 'InvoiceOverview', params: { id: item.id } })
    },
    findDiv (div) {
      return _.find(this.divs, ['division', div])
    }
  },
  components: {
    'status-chip': StatusChip
  }
}
</script>
